import {
  ORDENLABORATORIO_ERROR,
  ORDENLABORATORIO_LOADING,
  ORDENLABORATORIO_SUCCESS,
  ORDENLABORATORIO_RESET,
  ORDENLABORATORIO_ELIMINAR
  
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsPostSubirOrdenLaboratorio = (ordenDto, nextStep) => (dispatch) => {
  dispatch({
    type: ORDENLABORATORIO_LOADING,
  });

 axiosInstance().then(respuesta => {
  respuesta
  .post("/laboratorio/orden", ordenDto)
  .then((res) => {
    if(nextStep) nextStep(true);
    dispatch({
      type: ORDENLABORATORIO_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    if(nextStep) nextStep(false);
    
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
      origen: "portal",
    };

    dispatch({
      type: ORDENLABORATORIO_ERROR,
      payload: error,
    });
  });
 } )
};
export const wsDeleteOrdenLaboratorio = (idprotocolo,idremoto, nextStep) => (dispatch) => {
  dispatch({
    type: ORDENLABORATORIO_LOADING,
  });

 axiosInstance().then(respuesta => {
  respuesta
  .delete(`/laboratorio/orden/${idprotocolo}/${idremoto}`)
  .then((res) => {
    if(nextStep) nextStep();
    dispatch({
      type: ORDENLABORATORIO_ELIMINAR,
      payload: res.data,
    });
  })
  .catch((err) => {
    if(nextStep) nextStep();
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
      origen: "portal",
    };

    dispatch({
      type: ORDENLABORATORIO_ERROR,
      payload: error,
    });
  });
 } )
};

export const resetOrdenLaboratorio = () => (dispatch) => {
  dispatch({
    type: ORDENLABORATORIO_RESET,
  });
}


